var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.getVerifiedName()
      ? _c("h2", [_vm._v(_vm._s(_vm.$t("wp.wpServices")))])
      : _c("h2", [
          _vm._v(
            _vm._s(_vm.$t("wp.wpServices")) +
              " - " +
              _vm._s(_vm.getVerifiedName()) +
              " <" +
              _vm._s(_vm.getPhoneNumber()) +
              ">"
          ),
        ]),
    _vm._v(" "),
    _c("span", [
      _vm._v(" " + _vm._s(_vm.$t("wp.wpServicesIntegrationCompleted")) + " "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mt-5" }, [
      !!_vm.imageData
        ? _c("img", {
            key: _vm.imageRefreshKey,
            staticClass: "qr-code",
            attrs: { src: _vm.imageData, alt: "QR Code" },
          })
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }